/* eslint-disable */
/*
 * Atlas map runtime — draws Atlas choropleth and point maps that carry `config.meta` (version >= 1).
 *
 * Used by BOTH renderers so chat and PDF exports match:
 *   - atlas-backend: inlined into the headless page built by viz_renderer.build_map_html (window.AtlasMapRuntime)
 *   - client: copied verbatim to src/components/atlas/maps/atlasMapRuntime.js (module.exports)
 * Keep the two copies identical. The canonical copy lives in atlas-backend app/atlas/tools/viz_assets/.
 *
 * Framework-free: callers own the mapboxgl.Map and pass it in. No turf dependency.
 * Config fields it reads (all written by create_choropleth_map / create_data_point_map):
 *   type: 'choropleth_map' | 'data_point_map'
 *   geography_level, data {geoid: value}, value_format, value_label
 *   classes {method, breaks[k+1], colors[k], colors_dark[k], labels[k+1]} | classes {method:'categorical', categories:[{value,label,color,color_dark}]}
 *   highlight_geoids [...], area_labels 'name' | 'name_value' | null
 *   points [{lat,lng,role,color,radius,hollow,label,popup}]  (data_point_map) / points_overlay.points (choropleth)
 *   subject {lat,lng,label} | null, rings {center:[lng,lat], radii_miles:[...]} | null
 *   legend {title, items:[{label, kind, role, color, count, detail}]}
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AtlasMapRuntime = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var TILESETS = {
    state: { id: 'michael-rt.9fowxiad', layer: 'us_states-9ghuuu', geoid: 'GEOID', name: 'NAME' },
    county: { id: 'michael-rt.3at1878p', layer: 'us_counties-4kvhkl', geoid: 'GEOID', name: 'NAME' },
    zcta: { id: 'michael-rt.4c3ijtve', layer: 'us_zctas-8qweax', geoid: 'GEOID', name: null },
    tract: { id: 'michael-rt.9gixg01e', layer: 'us_tracts-6zymb3', geoid: 'GEOID', name: null },
    h3_hex: { id: 'michael-rt.4uco037u', layer: 'h3_hex_r8_tileset-3cxn9m', geoid: 'hex_id', name: null }
  };

  var THEMES = {
    light: {
      style: 'mapbox://styles/mapbox/light-v11', surface: '#ffffff', ink: '#111827', ink2: '#4b5563', muted: '#6b7280', halo: '#ffffff',
      land: '#f4f4f2', water: '#dde6ee', waterLabel: '#7d93a8', road: '#ffffff', roadCase: '#e7e7e4', admin: 'rgba(17,24,39,0.22)',
      ring: 'rgba(17,24,39,0.62)', subject: '#E26313', noData: '#e5e7eb', outline: '#ffffff',
      roles: { subject: '#E26313', peer: '#2a78d6', peer2: '#1baf7a', context: '#9ca3af', context2: '#6b7280', other: '#9ca3af', ink: '#111827' }
    },
    dark: {
      style: 'mapbox://styles/mapbox/dark-v11', surface: '#222226', ink: '#f9fafb', ink2: '#d1d5db', muted: '#9ca3af', halo: '#1b1b1f',
      land: '#1f1f23', water: '#16181d', waterLabel: '#5b6b7c', road: '#2e2e33', roadCase: '#26262b', admin: 'rgba(255,255,255,0.22)',
      ring: 'rgba(249,250,251,0.62)', subject: '#E26313', noData: '#34343a', outline: '#222226',
      roles: { subject: '#E26313', peer: '#3987e5', peer2: '#199e70', context: '#6b7280', context2: '#9ca3af', other: '#6b7280', ink: '#f9fafb' }
    }
  };
  function theme(name) { return THEMES[name] || THEMES.light; }
  function roleColor(t, role, fallback) { return (role && t.roles[role]) || fallback || t.roles.peer; }
  function hasMeta(config) { return !!(config && config.meta && config.meta.version >= 1); }
  function num(v) { if (v === null || v === undefined || v === '') return null; var n = Number(v); return isFinite(n) ? n : null; }

  // ---------------------------------------------------------------- formats (same rules as the chart runtime)
  function trim0(s) { return String(s).replace(/\.0+$/, '').replace(/(\.\d*?[1-9])0+$/, '$1'); }
  function pctText(p) { var a = Math.abs(p); return (a < 100 && Math.abs(p % 1) > 1e-9 ? p.toFixed(1) : String(Math.round(p))) + '%'; }
  var FORMATS = {
    money: function (v) { return (v < 0 ? '-$' : '$') + Math.round(Math.abs(v)).toLocaleString('en-US'); },
    money_compact: function (v) {
      var a = Math.abs(v), s = v < 0 ? '-$' : '$';
      if (a >= 1e9) return s + trim0((a / 1e9).toFixed(2)) + 'B';
      if (a >= 1e6) return s + trim0((a / 1e6).toFixed(2)) + 'M';
      if (a >= 1e4) return s + Math.round(a / 1e3) + 'k';
      if (a >= 1e3) return s + trim0((a / 1e3).toFixed(1)) + 'k';
      return s + Math.round(a);
    },
    percent: function (v) { return pctText(v); },
    ratio_percent: function (v) { return pctText(v * 100); },
    percentile: function (v) { return String(Math.round(v)); },
    number: function (v) { var a = Math.abs(v); return a >= 100 || Math.abs(v % 1) < 1e-9 ? Math.round(v).toLocaleString('en-US') : trim0(v.toFixed(a < 10 ? 2 : 1)); },
    compact: function (v) {
      var a = Math.abs(v), s = v < 0 ? '-' : '';
      if (a >= 1e9) return s + trim0((a / 1e9).toFixed(1)) + 'B';
      if (a >= 1e6) return s + trim0((a / 1e6).toFixed(1)) + 'M';
      if (a >= 1e4) return s + Math.round(a / 1e3) + 'k';
      if (a >= 1e3) return s + trim0((a / 1e3).toFixed(1)) + 'k';
      return FORMATS.number(v);
    },
    decimal: function (v) { return v.toFixed(2); },
    days: function (v) { return Math.round(v) + ' d'; }
  };
  FORMATS.currency = FORMATS.money_compact;
  function format(kind, v) { var n = num(v); if (n === null) return v === null || v === undefined || v === '' ? '—' : String(v); return (FORMATS[kind] || FORMATS.number)(n); }

  // ---------------------------------------------------------------- geometry (no turf)
  var R_MI = 3958.8;
  function destination(center, miles, bearingDeg) {
    var lat1 = center[1] * Math.PI / 180, lng1 = center[0] * Math.PI / 180, d = miles / R_MI, b = bearingDeg * Math.PI / 180;
    var lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(b));
    var lng2 = lng1 + Math.atan2(Math.sin(b) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));
    return [lng2 * 180 / Math.PI, lat2 * 180 / Math.PI];
  }
  function circle(center, miles, steps) {
    var ring = []; steps = steps || 128;
    for (var i = 0; i <= steps; i++) ring.push(destination(center, miles, (i / steps) * 360));
    return { type: 'Feature', geometry: { type: 'Polygon', coordinates: [ring] }, properties: { miles: miles } };
  }
  function ringArea(r) { var a = 0; for (var i = 0, j = r.length - 1; i < r.length; j = i++) a += (r[j][0] + r[i][0]) * (r[j][1] - r[i][1]); return Math.abs(a / 2); }
  function ringCentroid(r) {
    var x = 0, y = 0, a = 0;
    for (var i = 0, j = r.length - 1; i < r.length; j = i++) { var f = r[j][0] * r[i][1] - r[i][0] * r[j][1]; x += (r[j][0] + r[i][0]) * f; y += (r[j][1] + r[i][1]) * f; a += f; }
    if (!a) return r[0]; return [x / (3 * a), y / (3 * a)];
  }
  function inside(pt, r) {
    var c = false;
    for (var i = 0, j = r.length - 1; i < r.length; j = i++) {
      if (((r[i][1] > pt[1]) !== (r[j][1] > pt[1])) && (pt[0] < (r[j][0] - r[i][0]) * (pt[1] - r[i][1]) / (r[j][1] - r[i][1]) + r[i][0])) c = !c;
    }
    return c;
  }
  /** A label point inside the largest outer ring of a (Multi)Polygon geometry. */
  function labelPoint(geom) {
    var rings = [];
    if (!geom) return null;
    if (geom.type === 'Polygon') rings = [geom.coordinates[0]];
    else if (geom.type === 'MultiPolygon') rings = geom.coordinates.map(function (p) { return p[0]; });
    if (!rings.length) return null;
    var best = rings[0], bestA = -1;
    rings.forEach(function (r) { var a = ringArea(r); if (a > bestA) { bestA = a; best = r; } });
    var c = ringCentroid(best);
    if (inside(c, best)) return c;
    // widest horizontal chord through the centroid's latitude
    var xs = [];
    for (var i = 0, j = best.length - 1; i < best.length; j = i++) {
      var a1 = best[i], b1 = best[j];
      if ((a1[1] > c[1]) !== (b1[1] > c[1])) xs.push(a1[0] + (c[1] - a1[1]) * (b1[0] - a1[0]) / (b1[1] - a1[1]));
    }
    xs.sort(function (p, q) { return p - q; });
    var bx = null, bw = -1;
    for (var k = 0; k + 1 < xs.length; k += 2) if (xs[k + 1] - xs[k] > bw) { bw = xs[k + 1] - xs[k]; bx = (xs[k] + xs[k + 1]) / 2; }
    return bx === null ? c : [bx, c[1]];
  }
  function walk(coords, visit) { if (!coords) return; if (typeof coords[0] === 'number') { visit(coords[0], coords[1]); return; } for (var i = 0; i < coords.length; i++) walk(coords[i], visit); }

  // ---------------------------------------------------------------- basemap
  function basemapStyle(themeName) { return theme(themeName).style; }
  /** Quiet the Mapbox light/dark style: hide POIs, transit and buildings; soften roads, water and labels. */
  function quietBasemap(map, themeName) {
    var t = theme(themeName), style = map.getStyle(); if (!style || !style.layers) return;
    style.layers.forEach(function (l) {
      var id = l.id;
      try {
        if (/poi|transit|airport|ferry|aerialway|building|road-number|road-exit|golf|pitch|hillshade|contour/.test(id)) { map.setLayoutProperty(id, 'visibility', 'none'); return; }
        if (l.type === 'background') map.setPaintProperty(id, 'background-color', t.land);
        if (l.type === 'fill' && (id === 'land' || /landcover|landuse|national-park/.test(id))) map.setPaintProperty(id, 'fill-color', t.land);
        if (/^water$|water-shadow|waterway/.test(id)) { if (l.type === 'fill') map.setPaintProperty(id, 'fill-color', t.water); if (l.type === 'line') map.setPaintProperty(id, 'line-color', t.water); }
        if (l.type === 'line' && /road|bridge|tunnel/.test(id)) map.setPaintProperty(id, 'line-color', /case/.test(id) ? t.roadCase : t.road);
        if (l.type === 'line' && /admin/.test(id)) map.setPaintProperty(id, 'line-color', t.admin);
        if (l.type === 'symbol') {
          if (/road-label|road-intersection|path/.test(id)) { map.setPaintProperty(id, 'text-color', t.muted); map.setPaintProperty(id, 'text-halo-color', t.halo); return; }
          if (/settlement|state-label|country|place|natural|water/.test(id)) {
            map.setPaintProperty(id, 'text-color', /water|natural/.test(id) ? t.waterLabel : t.ink2);
            map.setPaintProperty(id, 'text-halo-color', t.halo); map.setPaintProperty(id, 'text-halo-width', 1.4);
          }
        }
      } catch (e) { /* layer lacks that property */ }
    });
  }

  // ---------------------------------------------------------------- classes
  function classIndex(v, breaks) { for (var i = 1; i < breaks.length - 1; i++) if (v < breaks[i]) return i - 1; return breaks.length - 2; }
  function areaColors(config, themeName) {
    var cls = config.classes || {}, dark = themeName === 'dark';
    if (cls.method === 'categorical') {
      var map = {};
      (cls.categories || []).forEach(function (c) { map[String(c.value)] = dark && c.color_dark ? c.color_dark : c.color; });
      return function (v) { return map[String(v)] || null; };
    }
    if (cls.method === 'uniform') { var u = (dark && cls.color_dark) || cls.color || '#2a78d6'; return function () { return u; }; }
    var colors = (dark && cls.colors_dark) || cls.colors || [], breaks = cls.breaks || [];
    return function (v) { var n = num(v); if (n === null || !colors.length || breaks.length < 2) return null; return colors[classIndex(n, breaks)]; };
  }
  function fillExpression(config, themeName, geoidProp) {
    var t = theme(themeName), colorOf = areaColors(config, themeName), pairs = [];
    Object.keys(config.data || {}).forEach(function (g) {
      var raw = config.data[g]; var v = raw && typeof raw === 'object' ? raw.value : raw;
      var c = colorOf(v); if (c) pairs.push(String(g), c);
    });
    if (!pairs.length) return t.noData;
    return ['match', ['get', geoidProp]].concat(pairs, [t.noData]);
  }

  // ---------------------------------------------------------------- layers
  /**
   * addLayers(map, config, {theme, beforeId, idPrefix}) — adds every Atlas layer for this config.
   * Returns {areaSource, areaLayer, pointLayers, tileset} so callers can wire hover popups.
   */
  function addLayers(map, config, opts) {
    opts = opts || {};
    var t = theme(opts.theme), prefix = opts.idPrefix || 'atlas', before = opts.beforeId;
    var out = { areaSource: null, areaLayer: null, pointLayers: [], tileset: null, areaFilter: null };
    if (config.type === 'choropleth_map') {
      var ts = TILESETS[config.geography_level] || TILESETS.county, sid = prefix + '-area';
      var ids = Object.keys(config.data || {});
      var filter = ['in', ['get', ts.geoid], ['literal', ids]];
      map.addSource(sid, { type: 'vector', url: 'mapbox://' + ts.id });
      map.addLayer({ id: sid + '-fill', type: 'fill', source: sid, 'source-layer': ts.layer, filter: filter,
        paint: { 'fill-color': fillExpression(config, opts.theme, ts.geoid), 'fill-opacity': num(config.fill_opacity) === null ? 0.82 : Math.max(0.55, num(config.fill_opacity)) } }, before);
      map.addLayer({ id: sid + '-line', type: 'line', source: sid, 'source-layer': ts.layer, filter: filter,
        paint: { 'line-color': t.outline, 'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.4, 12, 1.1], 'line-opacity': 0.9 } }, before);
      var hl = config.highlight_geoids || [];
      if (hl.length) {
        var hf = ['in', ['get', ts.geoid], ['literal', hl.map(String)]];
        map.addLayer({ id: sid + '-hl-case', type: 'line', source: sid, 'source-layer': ts.layer, filter: hf, paint: { 'line-color': t.surface, 'line-width': opts.print ? 5.5 : 4.5 } });
        map.addLayer({ id: sid + '-hl', type: 'line', source: sid, 'source-layer': ts.layer, filter: hf, paint: { 'line-color': t.subject, 'line-width': opts.print ? 3 : 2.2 } });
      }
      out.areaSource = sid; out.areaLayer = sid + '-fill'; out.tileset = ts; out.areaFilter = filter;
    }
    if (config.rings && config.rings.center && (config.rings.radii_miles || []).length) addRings(map, config.rings, t, prefix);
    var pts = config.type === 'data_point_map' ? (config.points || []) : ((config.points_overlay && config.points_overlay.points) || []);
    if (pts.length) out.pointLayers = addPoints(map, pts, t, prefix, opts.theme);
    if (config.subject && num(config.subject.lat) !== null && num(config.subject.lng) !== null) addSubject(map, config, t, prefix);
    return out;
  }

  function addRings(map, rings, t, prefix) {
    var c = [num(rings.center[0]), num(rings.center[1])], sid = prefix + '-rings';
    var radii = rings.radii_miles.map(num).filter(function (r) { return r && r > 0; });
    map.addSource(sid, { type: 'geojson', data: { type: 'FeatureCollection', features: radii.map(function (r) { return circle(c, r); }) } });
    map.addLayer({ id: sid, type: 'line', source: sid, paint: { 'line-color': t.ring, 'line-width': 1.6, 'line-dasharray': [2.5, 1.8] } });
    map.addSource(sid + '-lab', { type: 'geojson', data: { type: 'FeatureCollection', features: radii.map(function (r) {
      return { type: 'Feature', geometry: { type: 'Point', coordinates: destination(c, r, 0) }, properties: { t: (Math.round(r * 10) / 10) + ' mi' } };
    }) } });
    map.addLayer({ id: sid + '-lab', type: 'symbol', source: sid + '-lab', layout: { 'text-field': ['get', 't'], 'text-size': 11, 'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'], 'text-allow-overlap': true },
      paint: { 'text-color': t.ink, 'text-halo-color': t.halo, 'text-halo-width': 2 } });
  }

  function addPoints(map, pts, t, prefix, themeName) {
    var sid = prefix + '-points', feats = [];
    pts.forEach(function (p, i) {
      var lat = num(p.lat), lng = num(p.lng); if (lat === null || lng === null) return;
      var color = p.role ? roleColor(t, p.role, p.color) : (p.color || t.roles.peer);
      var props = { _i: i, _color: color, _r: num(p.radius) || 5, _hollow: p.hollow ? 1 : 0, _label: p.label || '', _z: num(p.z) || 0 };
      feats.push({ type: 'Feature', geometry: { type: 'Point', coordinates: [lng, lat] }, properties: props });
    });
    feats.sort(function (a, b) { return a.properties._z - b.properties._z; });
    map.addSource(sid, { type: 'geojson', data: { type: 'FeatureCollection', features: feats } });
    map.addLayer({ id: sid, type: 'circle', source: sid, layout: { 'circle-sort-key': ['get', '_z'] }, paint: {
      'circle-radius': ['get', '_r'],
      'circle-color': ['case', ['==', ['get', '_hollow'], 1], t.surface, ['get', '_color']],
      'circle-stroke-color': ['case', ['==', ['get', '_hollow'], 1], ['get', '_color'], t.surface],
      'circle-stroke-width': ['case', ['==', ['get', '_hollow'], 1], 1.6, ['case', ['<', ['get', '_r'], 3], 0, 1.5]],
      'circle-opacity': ['case', ['<', ['get', '_r'], 3], 0.6, 1], 'circle-stroke-opacity': ['case', ['<', ['get', '_r'], 3], 0.6, 1]
    } });
    var labelled = feats.some(function (f) { return f.properties._label; });
    if (labelled) {
      map.addLayer({ id: sid + '-lab', type: 'symbol', source: sid, filter: ['!=', ['get', '_label'], ''], layout: {
        'text-field': ['get', '_label'], 'text-size': 11, 'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'],
        'text-offset': [0, -1.25], 'text-anchor': 'bottom', 'text-padding': 2, 'symbol-sort-key': ['-', 0, ['get', '_z']]
      }, paint: { 'text-color': t.ink, 'text-halo-color': t.halo, 'text-halo-width': 1.6 } });
    }
    return [sid];
  }

  function addSubject(map, config, t, prefix) {
    var s = config.subject, sid = prefix + '-subject';
    var ink = s.color === 'ink' || config.subject_ink === true;
    var c = ink ? t.ink : t.subject;
    map.addSource(sid, { type: 'geojson', data: { type: 'Feature', geometry: { type: 'Point', coordinates: [num(s.lng), num(s.lat)] }, properties: { t: s.label || '' } } });
    map.addLayer({ id: sid + '-halo', type: 'circle', source: sid, paint: { 'circle-radius': 15, 'circle-color': c, 'circle-opacity': 0.16 } });
    map.addLayer({ id: sid + '-dot', type: 'circle', source: sid, paint: { 'circle-radius': 7, 'circle-color': c, 'circle-stroke-color': t.surface, 'circle-stroke-width': 2.5 } });
    if (s.label) {
      map.addLayer({ id: sid + '-lab', type: 'symbol', source: sid, layout: { 'text-field': ['get', 't'], 'text-size': 12.5, 'text-font': ['DIN Pro Bold', 'Arial Unicode MS Bold'],
        'text-anchor': 'left', 'text-offset': [1.2, 0], 'text-allow-overlap': true, 'text-line-height': 1.15, 'text-max-width': 14 },
        paint: { 'text-color': t.ink, 'text-halo-color': t.halo, 'text-halo-width': 2 } });
    }
  }

  /** Call once the area source has loaded (e.g. on the first 'idle'): adds name / value labels at each area. */
  function addAreaLabels(map, config, info, opts) {
    if (!info || !info.areaSource || !config.area_labels) return false;
    var t = theme((opts || {}).theme), ts = info.tileset, sid = info.areaSource + '-labels';
    if (map.getSource(sid)) return true;
    var fs = map.querySourceFeatures(info.areaSource, { sourceLayer: ts.layer, filter: info.areaFilter });
    if (!fs.length) return false;
    var by = {};
    fs.forEach(function (f) {
      var g = String(f.properties[ts.geoid]); var area = 0;
      if (f.geometry.type === 'Polygon') area = ringArea(f.geometry.coordinates[0]);
      else if (f.geometry.type === 'MultiPolygon') f.geometry.coordinates.forEach(function (p) { area += ringArea(p[0]); });
      if (!by[g] || area > by[g].area) by[g] = { f: f, area: area };
    });
    var names = config.area_names || {}, hl = (config.highlight_geoids || []).map(String);
    var feats = Object.keys(by).map(function (g) {
      var f = by[g].f, pt = labelPoint(f.geometry); if (!pt) return null;
      var raw = (config.data || {})[g]; var v = raw && typeof raw === 'object' ? raw.value : raw;
      var name = names[g] || (ts.name ? f.properties[ts.name] : g) || g;
      var text = config.area_labels === 'name_value' ? name + '\n' + format(config.value_format, v) : config.area_labels === 'value' ? format(config.value_format, v) : name;
      return { type: 'Feature', geometry: { type: 'Point', coordinates: pt }, properties: { t: text, hl: hl.indexOf(g) >= 0 ? 1 : 0 } };
    }).filter(Boolean);
    map.addSource(sid, { type: 'geojson', data: { type: 'FeatureCollection', features: feats } });
    map.addLayer({ id: sid, type: 'symbol', source: sid, layout: {
      'text-field': ['get', 't'], 'text-size': ['case', ['==', ['get', 'hl'], 1], 12.5, 11],
      'text-font': ['case', ['==', ['get', 'hl'], 1], ['literal', ['DIN Pro Bold', 'Arial Unicode MS Bold']], ['literal', ['DIN Pro Medium', 'Arial Unicode MS Regular']]],
      'text-line-height': 1.15, 'symbol-sort-key': ['-', 0, ['get', 'hl']], 'text-padding': 3
    }, paint: { 'text-color': t.ink, 'text-halo-color': t.halo, 'text-halo-width': 1.6 } });
    return true;
  }

  /** Bounds [[w,s],[e,n]] from explicit bounds, rings, points and subject; null if nothing to fit. */
  function bounds(config) {
    if (Array.isArray(config.bounds) && config.bounds.length === 2) return config.bounds;
    var w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
    var visit = function (x, y) { if (x === null || y === null) return; w = Math.min(w, x); s = Math.min(s, y); e = Math.max(e, x); n = Math.max(n, y); };
    if (config.type === 'choropleth_map') return null; // shaded-area maps fit to their areas (rings sit inside them)
    if (config.rings && config.rings.center) {
      var c = [num(config.rings.center[0]), num(config.rings.center[1])], r = Math.max.apply(null, (config.rings.radii_miles || [0]).map(num));
      if (r > 0) [0, 90, 180, 270].forEach(function (b) { var p = destination(c, r * 1.02, b); visit(p[0], p[1]); });
    } else {
      var pts = config.type === 'data_point_map' ? (config.points || []) : ((config.points_overlay && config.points_overlay.points) || []);
      pts.forEach(function (p) { visit(num(p.lng), num(p.lat)); });
      if (config.subject) visit(num(config.subject.lng), num(config.subject.lat));
    }
    if (!isFinite(w)) return null;
    if (w === e && s === n) { w -= 0.01; e += 0.01; s -= 0.01; n += 0.01; }
    return [[w, s], [e, n]];
  }

  /** Bounds of the loaded area features (call after the area source loads). */
  function areaBounds(map, info) {
    if (!info || !info.areaSource) return null;
    var fs = map.querySourceFeatures(info.areaSource, { sourceLayer: info.tileset.layer, filter: info.areaFilter });
    if (!fs.length) return null;
    var w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
    fs.forEach(function (f) { walk(f.geometry.coordinates, function (x, y) { w = Math.min(w, x); s = Math.min(s, y); e = Math.max(e, x); n = Math.max(n, y); }); });
    return isFinite(w) ? [[w, s], [e, n]] : null;
  }

  // ---------------------------------------------------------------- legend + hover
  /** {title, steps:{colors,labels,note}|null, categories:[...], items:[{kind,label,color,count,detail}]} */
  function legendModel(config, themeName) {
    var t = theme(themeName), dark = themeName === 'dark', cls = config.classes || {}, lg = config.legend || {};
    var model = { title: lg.title || config.legend_title || config.value_label || '', steps: null, categories: [], items: [] };
    if (config.type === 'choropleth_map') {
      if (cls.method === 'categorical') model.categories = (cls.categories || []).map(function (c) { return { label: c.label || String(c.value), color: dark && c.color_dark ? c.color_dark : c.color, count: c.count }; });
      else if (cls.method === 'uniform') model.categories = [{ label: cls.label || config.value_label || 'Selected areas', color: dark && cls.color_dark ? cls.color_dark : cls.color }];
      else if ((cls.colors || []).length) model.steps = { colors: (dark && cls.colors_dark) || cls.colors, labels: cls.labels || [], note: cls.note || '' };
    }
    (lg.items || []).forEach(function (it) {
      var color = it.kind === 'subject' || it.kind === 'outline' ? (it.ink ? t.ink : t.subject) : it.role ? roleColor(t, it.role, it.color) : it.color;
      model.items.push({ kind: it.kind || 'point', label: it.label, color: color, count: it.count, detail: it.detail || '' });
    });
    return model;
  }

  function esc(s) { return String(s === null || s === undefined ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /** Hover card HTML for an area feature. */
  function areaHoverHtml(config, feature, info) {
    var ts = info.tileset, g = String(feature.properties[ts.geoid]);
    var raw = (config.data || {})[g]; var v = raw && typeof raw === 'object' ? raw.value : raw;
    var name = (config.area_names || {})[g] || (ts.name ? feature.properties[ts.name] : null) || (config.geography_level === 'zcta' ? 'ZIP ' + g : config.geography_level === 'tract' ? 'Tract ' + g : g);
    var extra = ((config.area_details || {})[g]) || [];
    return '<div class="atlas-map-tt"><div class="atlas-map-tt-v">' + esc(format(config.value_format, v)) + '</div><div class="atlas-map-tt-l">' + esc(config.value_label || config.legend_title || '') + '</div>' +
      '<div class="atlas-map-tt-r"><span>' + esc(name) + '</span></div>' +
      extra.map(function (r) { return '<div class="atlas-map-tt-r"><span>' + esc(r[0]) + '</span><b>' + esc(r[1]) + '</b></div>'; }).join('') + '</div>';
  }
  /** Hover card HTML for a point, using the stored popup fields (formatted by name heuristics only for price/sqft). */
  function pointHoverHtml(config, feature) {
    var pts = config.type === 'data_point_map' ? (config.points || []) : ((config.points_overlay && config.points_overlay.points) || []);
    var p = pts[feature.properties._i] || {}, popup = p.popup || {}, keys = Object.keys(popup).slice(0, 9);
    var head = p.title || popup.address || popup.name || popup.community || p.label || '';
    var rows = keys.filter(function (k) { return popup[k] !== null && popup[k] !== '' && popup[k] !== head; }).map(function (k) {
      var v = popup[k], n = num(v), kk = k.toLowerCase();
      var txt = n === null ? String(v) : /price|value|cost|rent|income|ask/.test(kk) && !/per_sq|sqft|psf/.test(kk) ? format('money_compact', n) : /per_sq|psf|ppsf|price_per/.test(kk) ? format('money', n) : /pct|percent|share/.test(kk) ? format(n <= 1 ? 'ratio_percent' : 'percent', n) : format('number', n);
      return '<div class="atlas-map-tt-r"><span>' + esc(k.replace(/_/g, ' ')) + '</span><b>' + esc(txt) + '</b></div>';
    }).join('');
    return '<div class="atlas-map-tt">' + (head ? '<div class="atlas-map-tt-h">' + esc(head) + '</div>' : '') + rows + '</div>';
  }

  return {
    version: 1, TILESETS: TILESETS, THEMES: THEMES, FORMATS: FORMATS,
    hasMeta: hasMeta, basemapStyle: basemapStyle, quietBasemap: quietBasemap, addLayers: addLayers, addAreaLabels: addAreaLabels,
    bounds: bounds, areaBounds: areaBounds, legendModel: legendModel, areaHoverHtml: areaHoverHtml, pointHoverHtml: pointHoverHtml,
    format: format, circle: circle, destination: destination, labelPoint: labelPoint, classIndex: classIndex
  };
});
